module.exports = __webpack_public_path__ + "static/img/about_zhuzq02.63d6ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq02.png
// module id = 06cN
// module chunks = 1